module.exports = __webpack_public_path__ + "img/banner1.f779b9ba.png";